// App.js
import React from 'react';
import { Box } from "@mui/material";
import { useParams } from "react-router-dom";
import InvoiceForm from './widgets/InvoiceForm';



export default function EditInvoiceScreen() {


  const { id } = useParams();
  return (
    <Box>
      <Box sx={{ display: 'flex' }}>
            <Box width={"100%"}>
          <InvoiceForm formType={"edit"} formID= {id}>

          </InvoiceForm>
        </Box>
      </Box>
      
    </Box>


  )
}